// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1RU6t","footer":"ModalInfo_footer__3dJVB"};